import * as i0 from '@angular/core';
import { Directive, Input } from '@angular/core';

/**
 * @deprecated: use [textContent]="code"
 */
class TuiDocText {
    constructor() {
        this.code = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiDocText, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: TuiDocText, isStandalone: true, selector: "code[tuiDocText]", inputs: { code: ["tuiDocText", "code"] }, host: { properties: { "textContent": "code" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiDocText, decorators: [{
            type: Directive,
            args: [{
                    standalone: true,
                    selector: 'code[tuiDocText]',
                    host: {
                        '[textContent]': 'code',
                    },
                }]
        }], propDecorators: { code: [{
                type: Input,
                args: ['tuiDocText']
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiDocText };
